module.exports = __webpack_public_path__ + "img/logo_landing.1ebb417e.svg";